module.exports = __webpack_public_path__ + "static/media/topsmotjhdGd72.3d5c44cd.png";